import { Ref, memo } from 'react'

import {
  Td,
  Tr,
} from 'app/common/ui-components/table'


import { TransactionsType } from 'app/dataTypes/cafeteria/compensation/transactions'
import { Column } from './columns'
import { Cell } from './cell'


type Props = {
  columns: Array<Column>
  columnProps: Record<Column, {
    alignLeft?: boolean
    alignRight?: boolean
    alignCenter?: boolean
  }>
  transaction: TransactionsType
  reference?: Ref<'tr' | HTMLTableRowElement>,
}

export const TableRow = memo(({
  columns,
  columnProps,
  transaction,
  reference,
}: Props) => {
  return (
    <Tr
      reference={reference}
      interlineBorder
      alignTop
    >
      {columns.map(key => (
        <Td key={key} {...columnProps[key]}>
          <Cell
            columnKey={key}
            transaction={transaction}
          />
        </Td>
      ))}
    </Tr>)
})
